// Register-sida — placeholder tills vidare.
// I nuläget är registrering inaktiverad (beta-stadie). Användare läggs till
// manuellt i PocketBase. När vi öppnar publik registrering kommer vi att
// ersätta placeholdern med ett fungerande formulär.

import { Link } from 'react-router-dom';

export default function Register() {
  return (
    <div className="mx-auto max-w-md px-6 py-12">
      <h1 className="mb-6 text-2xl font-bold text-slate-900 dark:text-white">
        Skapa konto
      </h1>

      <div className="rounded-lg border border-amber-200 bg-amber-50 p-6 dark:border-amber-800 dark:bg-amber-900/20">
        <h2 className="mb-2 text-lg font-semibold text-amber-900 dark:text-amber-300">
          Beta-stadie
        </h2>
        <p className="mb-3 text-sm text-amber-800 dark:text-amber-400">
          Publik registrering är inte öppen ännu. Vi befinner oss i ett
          beta-stadie och lägger till användare manuellt i PocketBase.
        </p>
        <p className="text-sm text-amber-800 dark:text-amber-400">
          Har du redan ett konto?{' '}
          <Link
            to="/login"
            className="font-medium underline hover:no-underline"
          >
            Logga in
          </Link>
        </p>
      </div>
    </div>
  );
}
